export const CLEAR_PAGE_API_RESPONSE = 'page/CLEAR_PAGE_API_RESPONSE';
export const PAGE_PUBLISH_SUCCESS = 'page/PAGE_PUBLISH_SUCCESS';
export const PAGE_PUBLISH_REJECTED = 'page/PAGE_PUBLISH_REJECTED';
export const PAGE_UNPUBLISH_SUCCESS = 'page/PAGE_UNPUBLISH_SUCCESS';
export const PAGE_UNPUBLISH_REJECTED = 'page/PAGE_UNPUBLISH_REJECTED';
